import Source from './index.js';

const definition = {
    name: 'contact',
    pluralName: 'contacts',
    url: 'contact',
    route: 'contacts',
    entity: 'person',
    ignoreEntity: true,
    multiselect: true,

    defaultHeaders: [
        { key: "first_name", entity: "person", immovable: true },
        { key: "last_name", entity: "person", immovable: true },
        { key: "job_title", entity: "person" },
        { key: "company_name", entity: "org", noStore: true },
        { key: "email", entity: "person" },
        { key: "modified" }
    ],

    compileHeader: compileHeader,
    evaluateObjectFromHeader: evaluateObjectFromHeader,
};

const source =  new Source(definition);
source.definition = definition;
export default source;

function evaluateObjectFromHeader(header, record) {
    return header.entity === 'org' ?
        record.org :
        Source.prototype.evaluateObjectFromHeader.call(source, header, record);
}

function compileHeader(header) {
    if (!header.serverKey) Object.defineProperty(header, 'serverKey', {
        get: function() {
            var key = this.key;

            if (!this.system) key = 'data.' + key;
            if (this.entity === "org") key = 'org.' + key;

            return this.system ? key : ":" + key;
        }
    });
}
